import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { EndpointService } from './endpoint.service';
import { InsuranceOrderHistory, InsuranceOrderDetails, InsuranceSyncResult } from '../models/insurance-order';

export interface InsuranceAuthResponse {
  token: string;
  url: string;
}

interface InsuranceApiWrapper<T = InsuranceAuthResponse> {
  isSuccess: boolean;
  errors: string[];
  responseObject: T;
}

@Injectable({
  providedIn: 'root',
})
export class InsuranceService {
  private readonly baseUrl = `${environment.apiUrl}/api/insurance`;

  constructor(private http: HttpClient) {}

  getAuthToken(returnUrl?: string): Observable<InsuranceAuthResponse> {
    return this.http
      .get<InsuranceApiWrapper>(`${this.baseUrl}/auth-token`)
      .pipe(
        map((r) => {
          const response = r.responseObject;
          if (returnUrl) {
            const separator = response.url.includes('?') ? '&' : '?';
            return { ...response, url: `${response.url}${separator}returnUrl=${encodeURIComponent(returnUrl)}` };
          }
          return response;
        })
      );
  }

  getInsuranceOrders(userId: string): Observable<InsuranceOrderHistory[]> {
    return this.http
      .get<InsuranceApiWrapper<InsuranceOrderHistory[]>>(EndpointService.getAllInsuranceOrdersHistory(userId))
      .pipe(map((r) => r.responseObject));
  }

  getInsuranceOrderDetails(userId: string, orderId: number): Observable<InsuranceOrderDetails> {
    return this.http
      .get<InsuranceApiWrapper<InsuranceOrderDetails>>(EndpointService.getInsuranceOrderDetails(userId, orderId))
      .pipe(map((r) => r.responseObject));
  }

  syncInsuranceOrders(userId: string): Observable<InsuranceSyncResult> {
    return this.http
      .post<InsuranceApiWrapper<InsuranceSyncResult>>(EndpointService.syncInsuranceOrders(userId), {})
      .pipe(map((r) => r.responseObject));
  }
}
